import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Legacy `/apps` route. Programs listing now lives at `/programs` (the URL
 * reflects the content type). Kept as a permanent redirect so old bookmarks and
 * links keep working.
 */
export const Route = createFileRoute('/apps')({
  beforeLoad: () => {
    throw redirect({ to: '/programs', replace: true });
  },
});
